import {
  Tooltip as TooltipAnvil2,
  TooltipProps as TooltipAnvil2Props,
} from '@servicetitan/anvil2';
import classNames from 'classnames';
import { ReactElement, ReactNode, forwardRef } from 'react';
import styles from './Tooltip.module.css';

type TooltipProps = TooltipAnvil2Props & {
  children: ReactElement | ReactNode;
  text: string | ReactElement | ReactNode;
  tooltipClassName?: string;
  contentId?: string;
  open?: boolean;
  offset?: number;
  triggerClassName?: string;
  innerSpanClassName?: string;
};

/* Tooltip offset for button*/
export const OFFSET = 18;

export const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
  (
    {
      children,
      text,
      tooltipClassName,
      contentId,
      open,
      offset = OFFSET,
      placement = 'top',
      triggerClassName,
      innerSpanClassName,
      ...rest
    },
    ref,
  ) => {
    if (!text) {
      return <>{children}</>;
    }
    return (
      <TooltipAnvil2
        offset={offset}
        open={open}
        placement={placement}
        {...rest}
      >
        <TooltipAnvil2.Trigger className={triggerClassName}>
          <div
            ref={ref}
            tabIndex={0}
            className={classNames(styles.trigger, innerSpanClassName)}
          >
            {children}
          </div>
        </TooltipAnvil2.Trigger>
        <TooltipAnvil2.Content
          data-testid={contentId}
          className={classNames(styles.TooltipWrapper, tooltipClassName)}
        >
          {text}
        </TooltipAnvil2.Content>
      </TooltipAnvil2>
    );
  },
);
